import * as SentryMethods from '@sentry/react';

export const Sentry = SentryMethods;
